import {radialProgressiveBlur} from '@remotion/effects/radial-progressive-blur';
import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	HtmlInCanvas,
	interpolate,
	useCurrentFrame,
} from 'remotion';

export const CloseUp6Preview = () => {
	const frame = useCurrentFrame();
	const captureFrame = frame + 434;

	return (
		<HtmlInCanvas
			style={{width: 3180, height: 1848}}
			width={3180}
			height={1848}
			effects={[
				radialProgressiveBlur({
					center: [0.243, 0.212],
					width: 1.191,
					height: 1.794,
					start: 0.32,
				}),
			]}
		>
			<AbsoluteFill
				name="Canvas Capture"
				style={{
					width: 3180,
					height: 1848,
					translate: '-328.8px -360.1px',
					scale: 1.484,
					rotate: '0.942927 0.209821 -0.25858 42.59793deg',
					transformOrigin: '56.16% 78.11%',
				}}
				from={-434}
			>
				<Video
					src="https://remotion.media/studio-close-ups/studio-transform-editing.mp4"
					style={{
						position: 'absolute',
					}}
				/>
				<MacOSCursor
					cursor={interpolate(
						captureFrame,
						[12, 62, 195, 197, 286, 287, 288, 289, 729, 731],
						[
							'ew-resize',
							'custom',
							'ns-resize',
							'custom',
							'ew-resize',
							'custom',
							'ns-resize',
							'custom',
							'ns-resize',
							'auto',
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					)}
					customCursor={
						'url("data:image/svg+xml,%3Csvg%20width%3D%2229%22%20height%3D%2230%22%20viewBox%3D%220%200%2083%2085%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M58.673%2035.4941C58.6612%2035.1059%2058.6552%2034.9899%2058.6346%2034.4705L58.605%2033.8746C58.608%2033.9357%2058.5753%2033.3889%2058.5813%2033.4469L58.5695%2033.2635L54.9726%2033.508V33.5201C54.9874%2033.7371%2054.9992%2033.9389%2055.011%2034.1587C55.011%2034.1556%2055.0851%2036.3955%2055.0851%2036.3924L55.0881%2036.4688L55.0851%2036.4382L55.0881%2036.5268V36.591V36.5604V36.6521V36.6246V36.7163V36.6857L55.0911%2036.7927L55.0881%2036.7621L55.0911%2036.8844V36.8538V36.9913V36.9607V37.1441L55.0908%2037.1166V37.3C55.0908%2040.1263%2054.8952%2043.0781%2054.4568%2046.0083C55.7693%2045.6263%2057.0555%2045.1771%2058.273%2044.6517C58.5605%2042.2072%2058.6966%2039.7506%2058.6966%2037.3031C58.6936%2036.9149%2058.6906%2036.527%2058.6848%2036.1389L58.673%2035.4941ZM21.7249%2051.5816L11.6923%2048.5781L13.6418%2046.4055C11.1501%2043.9916%209.3219%2040.9118%209.3219%2037.3C9.33972%2034.501%2010.3589%2032.133%2012.0242%2029.9697C14.4835%2026.8805%2017.9916%2024.5982%2021.9176%2022.9633C21.5738%2024.4421%2021.2893%2025.9362%2021.0613%2027.4426C19.3486%2028.3349%2017.7752%2029.386%2016.4095%2030.6144C14.7415%2032.1421%2013.3428%2034.0304%2013.0051%2036.3039C12.7799%2037.8317%2013.0852%2039.2831%2013.7724%2040.6338C14.3562%2041.7765%2015.1886%2042.8063%2016.0896%2043.674L18.0364%2041.5015L21.7249%2051.5816ZM34.2108%2019.8313C36.6997%2019.5167%2039.1175%2019.3792%2041.3219%2019.3792C46.5515%2019.3792%2051.8463%2020.0576%2056.8656%2021.5854C63.7397%2023.6785%2073.2715%2028.711%2073.3219%2037.3001C73.3041%2040.096%2072.2879%2042.464%2070.6226%2044.6274C64.2492%2052.639%2050.8152%2055.221%2041.3218%2055.221C38.6848%2055.221%2035.9232%2055.056%2033.3307%2054.6647L33.8196%2050.9828C36.2492%2051.3495%2038.8536%2051.5022%2041.3248%2051.5022C49.3544%2051.5022%2059.9855%2049.6047%2066.2374%2043.9856C68.1455%2042.2377%2069.6953%2040.0224%2069.7189%2037.3C69.6804%2032.8542%2065.5411%2029.6123%2062.0922%2027.7239C55.9115%2024.3841%2048.2344%2023.0948%2041.3218%2023.0948C38.7026%2023.0948%2035.8047%2023.2965%2032.8715%2023.7639C33.2479%2022.4132%2033.6923%2021.0965%2034.2108%2019.8313ZM50.8745%2058.1816C52.3146%2057.9493%2053.7634%2057.6652%2055.1974%2057.317C52.6789%2063.6206%2048.1633%2070.2572%2041.3218%2070.3C38.6077%2070.2816%2036.3114%2069.2337%2034.2137%2067.5163C26.4448%2060.9408%2023.9441%2047.09%2023.9441%2037.3C23.9441%2031.91%2024.602%2026.4466%2026.0834%2021.2705C28.1131%2014.1817%2032.9931%204.35195%2041.322%204.3C45.63%204.3%2049.1057%207.12951%2051.5916%2010.5272L53.8967%208.76404L55.7041%2019.3699L46.3885%2014.5025L48.6936%2012.7393C46.9723%2010.3347%2044.3528%208.01873%2041.3217%208.01873C37.0106%208.05836%2033.8669%2012.3302%2032.0358%2015.8868C28.7972%2022.2546%2027.5469%2030.1715%2027.5469%2037.3001C27.5469%2045.5806%2029.387%2056.544%2034.8388%2062.9912C36.5337%2064.9589%2038.6788%2066.5571%2041.3217%2066.5815C45.6328%2066.5418%2048.7765%2062.2731%2050.6076%2058.7165L50.8745%2058.1816Z%22%20fill%3D%22black%22%20stroke%3D%22white%22%20stroke-width%3D%223%22%20stroke-linejoin%3D%22round%22%20paint-order%3D%22stroke%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2283%22%20height%3D%2285%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%225%22%20stdDeviation%3D%223.15%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.25%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 15 13, alias'
					}
					style={{
						position: 'absolute',
						left: 0,
						top: 0,
						scale: interpolate(
							captureFrame,
							[0, 100, 164, 222, 276, 308, 342, 401, 434, 621],
							[3.5, 3.15, 3.5, 3.15, 3.5, 3.15, 3.5, 3.15, 4.42, 3.5],
							{
								easing: [
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
								],
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
						translate: interpolate(
							captureFrame,
							[
								12, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75,
								76, 78, 79, 80, 81, 82, 83, 84, 85, 115, 116, 117, 118, 119,
								120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132,
								133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145,
								146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158,
								159, 160, 161, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180,
								181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193,
								194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206,
								207, 211, 212, 213, 215, 216, 217, 218, 219, 233, 234, 235, 236,
								237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249,
								250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262,
								263, 264, 265, 266, 267, 268, 269, 270, 285, 286, 287, 288, 289,
								290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302,
								303, 304, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 334,
								335, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364,
								365, 367, 368, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380,
								381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393,
								394, 395, 396, 397, 398, 399, 400, 401, 402, 412, 413, 414, 415,
								416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427, 428,
								429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440, 441,
								442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453, 454,
								455, 456, 457, 458, 459, 460, 461, 462, 463, 464, 465, 466, 467,
								468, 469, 470, 471, 472, 473, 474, 475, 476, 477, 478, 479, 480,
								481, 482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493,
								494, 495, 496, 497, 498, 499, 500, 501, 502, 503, 504, 505, 506,
								507, 508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518, 519,
								520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 530, 531, 532,
								533, 534, 535, 536, 537, 538, 539, 540, 541, 542, 543, 544, 545,
								546, 547, 548, 549, 550, 551, 552, 553, 554, 555, 556, 557, 558,
								559, 560, 561, 562, 563, 564, 565, 566, 567, 568, 569, 570, 571,
								572, 573, 574, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584,
								585, 586, 587, 588, 589, 590, 591, 592, 593, 594, 595, 596, 597,
								598, 601, 602, 724, 725, 726, 727, 728, 729, 730, 731, 732, 832,
								833, 861, 862,
							],
							[
								'613.8671875px 759.0078125px',
								'613.8671875px 759.0078125px',
								'1887.34765625px 1084.685546875px',
								'1887.34765625px 1098.712890625px',
								'1887.34765625px 1109.404296875px',
								'1887.34765625px 1127.79296875px',
								'1887.34765625px 1146.181640625px',
								'1887.34765625px 1168.931640625px',
								'1887.34765625px 1187.3203125px',
								'1887.34765625px 1205.708984375px',
								'1887.34765625px 1220.76171875px',
								'1887.34765625px 1231.453125px',
								'1887.34765625px 1242.14453125px',
								'1891.01171875px 1249.5px',
								'1892.337890625px 1252.15234375px',
								'1893.6640625px 1256.130859375px',
								'1893.6640625px 1257.224609375px',
								'1893.6640625px 1257.224609375px',
								'1894.580078125px 1259.466796875px',
								'1897.73828125px 1264.470703125px',
								'1900.896484375px 1269.474609375px',
								'1905.900390625px 1274.478515625px',
								'1908.552734375px 1277.130859375px',
								'1909.87890625px 1279.783203125px',
								'1910.97265625px 1281.109375px',
								'1910.97265625px 1281.109375px',
								'1910.97265625px 1280.671875px',
								'1910.97265625px 1277.0625px',
								'1910.97265625px 1274.13671875px',
								'1910.97265625px 1269.48828125px',
								'1910.97265625px 1259.3984375px',
								'1910.97265625px 1253.177734375px',
								'1910.97265625px 1249.486328125px',
								'1910.97265625px 1244.072265625px',
								'1910.97265625px 1236.251953125px',
								'1910.97265625px 1229.83984375px',
								'1910.97265625px 1226.107421875px',
								'1912.8046875px 1215.033203125px',
								'1914.63671875px 1209.099609375px',
								'1916.099609375px 1203.97265625px',
								'1918.19140625px 1196.09765625px',
								'1919.77734375px 1191.88671875px',
								'1920.693359375px 1189.384765625px',
								'1922.59375px 1184.162109375px',
								'1924.69921875px 1177.517578125px',
								'1925.369140625px 1174.93359375px',
								'1926.06640625px 1170.927734375px',
								'1926.72265625px 1169.57421875px',
								'1930.400390625px 1161.466796875px',
								'1931.125px 1159.51171875px',
								'1933.72265625px 1153.578125px',
								'1935.841796875px 1148.0546875px',
								'1939.123046875px 1139.33203125px',
								'1940.640625px 1136.583984375px',
								'1942.814453125px 1132.318359375px',
								'1944.865234375px 1128.23046875px',
								'1947.626953125px 1123.9921875px',
								'1948.310546875px 1122.625px',
								'1948.87109375px 1121.380859375px',
								'1949.41796875px 1120.2734375px',
								'1949.85546875px 1119.275390625px',
								'1952.234375px 1115.65234375px',
								'1952.904296875px 1114.353515625px',
								'1955.26953125px 1109.568359375px',
								'1956.841796875px 1106.95703125px',
								'1960.314453125px 1100.681640625px',
								'1964.388671875px 1090.140625px',
								'1965.755859375px 1086.203125px',
								'1967.068359375px 1082.34765625px',
								'1967.451171875px 1079.94140625px',
								'1967.984375px 1078.90234375px',
								'1968.244140625px 1077.53515625px',
								'1968.244140625px 1077.53515625px',
								'1970.951171875px 1077.53515625px',
								'2032.173828125px 1086.271484375px',
								'2097.005859375px 1114.55859375px',
								'2150.791015625px 1135.39453125px',
								'2270.296875px 1182.78125px',
								'2358.029296875px 1219.052734375px',
								'2392.578125px 1229.62109375px',
								'2420.71484375px 1245.357421875px',
								'2434.7421875px 1250.033203125px',
								'2439.513671875px 1252.958984375px',
								'2440.83984375px 1255.611328125px',
								'2440.83984375px 1258.263671875px',
								'2440.83984375px 1258.263671875px',
								'2440.83984375px 1260.68359375px',
								'2440.83984375px 1263.103515625px',
								'2440.83984375px 1268.107421875px',
								'2442.671875px 1278.798828125px',
								'2466.1328125px 1308.97265625px',
								'2498.849609375px 1337.833984375px',
								'2540.015625px 1375.14453125px',
								'2588.11328125px 1418.8671875px',
								'2622.880859375px 1449.259765625px',
								'2661.490234375px 1480.158203125px',
								'2683.43359375px 1502.1015625px',
								'2688.109375px 1509.115234375px',
								'2697.296875px 1518.302734375px',
								'2699.94921875px 1520.955078125px',
								'2702.6015625px 1522.28125px',
								'2702.6015625px 1522.28125px',
								'2703.53125px 1522.28125px',
								'2703.53125px 1522.28125px',
								'2704.857421875px 1523.279296875px',
								'2704.857421875px 1523.279296875px',
								'2705.85546875px 1523.279296875px',
								'2705.85546875px 1523.279296875px',
								'2705.85546875px 1524.208984375px',
								'2705.85546875px 1524.208984375px',
								'2705.85546875px 1525.09765625px',
								'2706.853515625px 1525.09765625px',
								'2706.853515625px 1525.09765625px',
								'2706.853515625px 1526.02734375px',
								'2706.853515625px 1527.12109375px',
								'2706.853515625px 1528.21484375px',
								'2707.8515625px 1529.212890625px',
								'2707.8515625px 1529.212890625px',
								'2709.1640625px 1529.212890625px',
								'2714.482421875px 1529.212890625px',
								'2720.8125px 1527.0390625px',
								'2722.494140625px 1526.2734375px',
								'2732.1875px 1520.8046875px',
								'2732.1875px 1520.8046875px',
								'2746.65234375px 1513.626953125px',
								'2749.22265625px 1511.083984375px',
								'2755.40234375px 1507.638671875px',
								'2757.904296875px 1506.0390625px',
								'2769.716796875px 1495.62109375px',
								'2773.380859375px 1492.1484375px',
								'2787.818359375px 1481.56640625px',
								'2791.796875px 1477.84765625px',
								'2799.494140625px 1471.080078125px',
								'2806.029296875px 1465.48828125px',
								'2808.736328125px 1462.822265625px',
								'2819.60546875px 1450.06640625px',
								'2826.03125px 1442.68359375px',
								'2833.796875px 1431.41796875px',
								'2838.486328125px 1423.87109375px',
								'2840.318359375px 1420.931640625px',
								'2844.119140625px 1413.603515625px',
								'2847.919921875px 1406.001953125px',
								'2851.501953125px 1399.384765625px',
								'2855.015625px 1393.02734375px',
								'2858.81640625px 1385.466796875px',
								'2860.716796875px 1381.638671875px',
								'2866.349609375px 1370.318359375px',
								'2868.427734375px 1364.958984375px',
								'2870.751953125px 1354.240234375px',
								'2874.4296875px 1344.984375px',
								'2880.021484375px 1331.28515625px',
								'2884.068359375px 1321.810546875px',
								'2887.69140625px 1314.919921875px',
								'2889.974609375px 1311.59765625px',
								'2891.478515625px 1308.603515625px',
								'2891.478515625px 1308.603515625px',
								'2889.728515625px 1308.603515625px',
								'2835.916015625px 1308.603515625px',
								'2773.61328125px 1299.83984375px',
								'2719.80078125px 1283.3515625px',
								'2665.98828125px 1266.86328125px',
								'2535.859375px 1236.197265625px',
								'2417.37890625px 1212.490234375px',
								'2298.8984375px 1176.943359375px',
								'2191.013671875px 1142.955078125px',
								'2128.7109375px 1129.296875px',
								'2050.48046875px 1119.5078125px',
								'1996.66796875px 1119.5078125px',
								'1950.29296875px 1119.5078125px',
								'1922.12890625px 1119.5078125px',
								'1903.712890625px 1119.5078125px',
								'1896.330078125px 1119.5078125px',
								'1893.650390625px 1119.5078125px',
								'1892.310546875px 1119.5078125px',
								'1891.298828125px 1119.5078125px',
								'1891.298828125px 1119.5078125px',
								'1891.298828125px 1118.6328125px',
								'1891.298828125px 1117.251953125px',
								'1891.298828125px 1116.171875px',
								'1891.298828125px 1115.0234375px',
								'1891.298828125px 1111.509765625px',
								'1891.298828125px 1107.654296875px',
								'1891.298828125px 1105.53515625px',
								'1891.298828125px 1105.53515625px',
								'1891.298828125px 1102.91015625px',
								'1891.298828125px 1102.91015625px',
								'1891.298828125px 1101.76171875px',
								'1891.298828125px 1101.76171875px',
								'1891.298828125px 1100.025390625px',
								'1891.298828125px 1077.248046875px',
								'1886.923828125px 1023.435546875px',
								'1863.216796875px 903.90234375px',
								'1857.802734375px 838.482421875px',
								'1843.638671875px 768.7421875px',
								'1836.40625px 712.00390625px',
								'1833.548828125px 693.587890625px',
								'1833.548828125px 688.556640625px',
								'1831.703125px 683.525390625px',
								'1831.703125px 683.525390625px',
								'1830.595703125px 681.310546875px',
								'1830.595703125px 681.310546875px',
								'1830.595703125px 680.3671875px',
								'1830.595703125px 680.3671875px',
								'1828.33984375px 680.3671875px',
								'1819.97265625px 680.3671875px',
								'1809.25390625px 680.3671875px',
								'1790.837890625px 680.3671875px',
								'1762.673828125px 680.3671875px',
								'1716.298828125px 695.802734375px',
								'1676.3359375px 717.431640625px',
								'1643.072265625px 744.98046875px',
								'1610.328125px 773.841796875px',
								'1588.357421875px 795.78515625px',
								'1575.123046875px 811.330078125px',
								'1569.5859375px 818.685546875px',
								'1566.90625px 821.337890625px',
								'1564.2265625px 823.990234375px',
								'1561.546875px 825.31640625px',
								'1556.515625px 825.31640625px',
								'1547.79296875px 825.31640625px',
								'1540.41015625px 825.31640625px',
								'1533.02734375px 823.470703125px',
								'1525.64453125px 816.087890625px',
								'1518.26171875px 810.55078125px',
								'1510.87890625px 803.16796875px',
								'1503.49609375px 795.78515625px',
								'1497.958984375px 790.248046875px',
								'1495.279296875px 787.568359375px',
								'1493.939453125px 786.228515625px',
								'1492.845703125px 785.134765625px',
								'1491.505859375px 783.794921875px',
								'1491.505859375px 782.6875px',
								'1491.505859375px 782.6875px',
								'1491.505859375px 782.16796875px',
								'1491.505859375px 782.16796875px',
								'1491.505859375px 781.224609375px',
								'1491.505859375px 781.224609375px',
								'1491.505859375px 779.228515625px',
								'1491.505859375px 775.578125px',
								'1491.505859375px 771.572265625px',
								'1494.80078125px 768.55078125px',
								'1507.638671875px 757.6953125px',
								'1518.712890625px 747.49609375px',
								'1518.712890625px 747.49609375px',
								'1528.98046875px 739.580078125px',
								'1542.87109375px 730.81640625px',
								'1548.4765625px 726.60546875px',
								'1554.73828125px 723.70703125px',
								'1560.056640625px 720.466796875px',
								'1566.345703125px 716.939453125px',
								'1568.984375px 715.271484375px',
								'1579.1015625px 711.662109375px',
								'1586.45703125px 707.970703125px',
								'1597.1484375px 703.787109375px',
								'1600.033203125px 701.8046875px',
								'1610.205078125px 696.9921875px',
								'1621.279296875px 692.5078125px',
								'1633.7890625px 688.666015625px',
								'1646.3125px 685.09765625px',
								'1657.93359375px 682.376953125px',
								'1674.708984375px 679.1640625px',
								'1685.728515625px 679.02734375px',
								'1691.01953125px 679px',
								'1694.697265625px 679px',
								'1706.27734375px 679px',
								'1710.87109375px 679px',
								'1716.982421875px 679px',
								'1722.314453125px 681.10546875px',
								'1727.482421875px 684.22265625px',
								'1732.677734375px 687.490234375px',
								'1738.10546875px 693.587890625px',
								'1744.66796875px 701.107421875px',
								'1751.3671875px 713.64453125px',
								'1759.583984375px 727.767578125px',
								'1759.583984375px 727.767578125px',
								'1766.583984375px 741.794921875px',
								'1771.013671875px 752.609375px',
								'1776.87890625px 766.47265625px',
								'1781.69140625px 779.5703125px',
								'1786.080078125px 790.9453125px',
								'1790.947265625px 807.611328125px',
								'1792.1640625px 813.162109375px',
								'1793.462890625px 822.595703125px',
								'1794.70703125px 832.015625px',
								'1795.896484375px 841.33984375px',
								'1797.05859375px 852.044921875px',
								'1797.05859375px 871.623046875px',
								'1797.05859375px 890.859375px',
								'1797.05859375px 896.765625px',
								'1796.087890625px 909.576171875px',
								'1792.068359375px 925.01171875px',
								'1788.1171875px 934.376953125px',
								'1784.248046875px 942.169921875px',
								'1780.693359375px 948.58203125px',
								'1777.166015625px 954.912109375px',
								'1773.966796875px 959.916015625px',
								'1770.671875px 966.478515625px',
								'1766.201171875px 971.98828125px',
								'1760.9375px 978.154296875px',
								'1756.0703125px 984.8125px',
								'1751.4765625px 990.376953125px',
								'1747.005859375px 994.998046875px',
								'1742.029296875px 998.224609375px',
								'1740.51171875px 999.6328125px',
								'1736.546875px 1002.626953125px',
								'1728.931640625px 1007.42578125px',
								'1728.931640625px 1007.42578125px',
								'1720.49609375px 1012.142578125px',
								'1715.369140625px 1015.068359375px',
								'1706.373046875px 1019.443359375px',
								'1699.11328125px 1021.42578125px',
								'1691.525390625px 1023.326171875px',
								'1682.255859375px 1024.775390625px',
								'1675.884765625px 1024.857421875px',
								'1675.884765625px 1024.857421875px',
								'1662.0625px 1026.689453125px',
								'1657.03125px 1026.689453125px',
								'1647.078125px 1026.689453125px',
								'1639.353515625px 1026.689453125px',
								'1628.771484375px 1026.689453125px',
								'1628.771484375px 1026.689453125px',
								'1617.806640625px 1026.689453125px',
								'1606.609375px 1026.689453125px',
								'1593.060546875px 1026.689453125px',
								'1581.548828125px 1026.689453125px',
								'1575.13671875px 1026.689453125px',
								'1572.607421875px 1026.689453125px',
								'1563.310546875px 1026.689453125px',
								'1561.287109375px 1026.689453125px',
								'1553.80859375px 1024.4609375px',
								'1551.15625px 1022.943359375px',
								'1548.421875px 1021.302734375px',
								'1537.34765625px 1014.04296875px',
								'1529.69140625px 1007.48046875px',
								'1517.71484375px 996.255859375px',
								'1511.75390625px 990.30859375px',
								'1502.56640625px 982.283203125px',
								'1490.34375px 970.060546875px',
								'1482.9609375px 962.677734375px',
								'1475.00390625px 953.244140625px',
								'1469.37109375px 945.79296875px',
								'1464.61328125px 939.1484375px',
								'1463.041015625px 937.384765625px',
								'1459.5px 930.740234375px',
								'1457.435546875px 927.85546875px',
								'1456.642578125px 925.052734375px',
								'1455.26171875px 922.27734375px',
								'1455.26171875px 922.27734375px',
								'1452.1171875px 917.41015625px',
								'1452.1171875px 915.482421875px',
								'1451.037109375px 911.61328125px',
								'1449.150390625px 908.6328125px',
								'1448.193359375px 905.830078125px',
								'1446.89453125px 902.04296875px',
								'1445.5px 898.16015625px',
								'1443.39453125px 890.462890625px',
								'1442.697265625px 887.82421875px',
								'1440.400390625px 882.724609375px',
								'1438.541015625px 875.341796875px',
								'1437.078125px 871.103515625px',
								'1435.30078125px 864.677734375px',
								'1432.443359375px 856.515625px',
								'1430.515625px 851.251953125px',
								'1428.615234375px 845.072265625px',
								'1428.615234375px 845.072265625px',
								'1426.6875px 837.580078125px',
								'1424.048828125px 829.47265625px',
								'1423.283203125px 826.615234375px',
								'1421.9296875px 822.541015625px',
								'1421.9296875px 822.541015625px',
								'1420.8359375px 818.986328125px',
								'1420.8359375px 817.98828125px',
								'1419.6875px 816.771484375px',
								'1419.6875px 816.771484375px',
								'1419.49609375px 814.337890625px',
								'1418.8671875px 812.259765625px',
								'1418.115234375px 808.814453125px',
								'1418.1015625px 807.419921875px',
								'1417.41796875px 804.685546875px',
								'1416.748046875px 802.005859375px',
								'1415.462890625px 796.947265625px',
								'1415.134765625px 795.224609375px',
								'1413.37109375px 786.802734375px',
								'1412.3046875px 780.47265625px',
								'1412.3046875px 780.47265625px',
								'1410.390625px 771.490234375px',
								'1407.6015625px 760.12890625px',
								'1407.505859375px 757.408203125px',
								'1405.619140625px 748.3984375px',
								'1405.60546875px 743.33984375px',
								'1405.60546875px 743.33984375px',
								'1404.265625px 735.205078125px',
								'1403.541015625px 729.01171875px',
								'1402.734375px 726.564453125px',
								'1401.845703125px 721.95703125px',
								'1401.845703125px 721.95703125px',
								'1401.06640625px 717.759765625px',
								'1399.78125px 714.984375px',
								'1399.69921875px 712.181640625px',
								'1399.671875px 709.43359375px',
								'1399.001953125px 708.09375px',
								'1398.33203125px 704.34765625px',
								'1397.251953125px 700.697265625px',
								'1397.087890625px 699.2890625px',
								'1396.96484375px 696.71875px',
								'1396.96484375px 696.71875px',
								'1395.92578125px 694.052734375px',
								'1395.87109375px 692.794921875px',
								'1395.81640625px 690.333984375px',
								'1395.81640625px 690.333984375px',
								'1395.802734375px 689.130859375px',
								'1394.462890625px 687.9140625px',
								'1394.462890625px 686.57421875px',
								'1393.943359375px 683.306640625px',
								'1393.21875px 680.61328125px',
								'1393.21875px 680.61328125px',
								'1392.53515625px 677.03125px',
								'1391.796875px 674.939453125px',
								'1391.7421875px 673.66796875px',
								'1391.7421875px 673.66796875px',
								'1391.728515625px 672.546875px',
								'1391.728515625px 672.546875px',
								'1391.71484375px 671.603515625px',
								'1391.71484375px 671.603515625px',
								'1454.33203125px 665.669921875px',
								'1603.4375px 602.943359375px',
								'1762.44140625px 515.662109375px',
								'2001.412109375px 372.3671875px',
								'2218.04296875px 232.216796875px',
								'2218.04296875px 232.216796875px',
								'2345.13671875px 150.5px',
								'2539.236328125px 41.91796875px',
								'2539.236328125px 41.91796875px',
								'2743.794921875px 210.861328125px',
								'2743.794921875px 210.861328125px',
								'485.10546875px 542.705078125px',
							],
							{
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
					}}
				/>
			</AbsoluteFill>
		</HtmlInCanvas>
	);
};

export const CloseUp6 = () => {
	return (
		<Composition
			id="RotationControl"
			component={CloseUp6Preview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={121}
		/>
	);
};
